import axios from "axios";

export function signUpAPI(action) {
  const email = action.email;
  const password = action.password;
  const securityQuestion = action.securityQuestion;
  const securityAnswer = action.securityAnswer;

  const metaData = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  const payload = {
    email: email,
    password: password,
    securityQuestion: securityQuestion,
    securityAnswer: securityAnswer,
  };

  return new Promise((resolve) => {
    axios
      .post(`${process.env.REACT_APP_BACKEND}/sign_up`, payload, metaData)
      .then((response) => resolve(response.data))
      .catch((error) => resolve(error.response.data));
  });
}
